module.exports = __webpack_public_path__ + "img/user-3.1156e1cf.svg";